import {Component, inject, Input, ViewChild} from '@angular/core';
import {CapitalCasePipe} from "../../../pipes/capital-case.pipe";
import {DxDataGridComponent, DxFormComponent, DxTemplateDirective} from "devextreme-angular";
import {
    DxiButtonComponent,
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent, DxoFilterRowComponent, DxoHeaderFilterComponent, DxoLoadPanelComponent, DxoPagerComponent, DxoPagingComponent,
    DxoScrollingComponent, DxoSortingComponent, DxoToolbarComponent
} from "devextreme-angular/ui/nested";
import {
    DataSources,
    EmailLogGridViewDto,
    PermissionType,
    AccessType,
    AuthService,
    NotificationType
} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {GridPageComponent, FilterConfig} from "../../common/grid-page.component";
import {EmailLogPopupComponent} from "./email-log-popup/email-log-popup.component";

@Component({
    selector: 'app-change-requests',
    imports: [
        CapitalCasePipe,
        DxDataGridComponent,
        DxTemplateDirective,
        DxiButtonComponent,
        DxiColumnComponent,
        DxiItemComponent,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoFilterRowComponent,
        DxoHeaderFilterComponent,
        DxoLoadPanelComponent,
        DxoPagerComponent,
        DxoPagingComponent,
        DxoScrollingComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxFormComponent,
        FilterPanelComponent,
        EmailLogPopupComponent
    ],
    templateUrl: './email-logs.component.html',
    styleUrl: './email-logs.component.scss',
})
export class EmailLogsComponent extends GridPageComponent<EmailLogGridViewDto> {
    protected dataSources = inject(DataSources);
    protected auth = inject(AuthService);

    constructor() {
        super();
        this.init(EmailLogGridViewDto);
    }

    @ViewChild(DxDataGridComponent, {static: true}) dataGrid: DxDataGridComponent;

    @Input() employeeId: string | null = null;

    dataSource = this.dataSources.emailLogs();
    typeOptions = EnumUtils.getEnumOptions(NotificationType);
    protected override exportName: string = "Email Logs";

    protected override filterConfig: FilterConfig[] = [
        {field: 'created', op: ">="},
        {field: 'type'},
        {field: 'subject', op: 'contains'}
    ];

    protected readonly PermissionType = PermissionType;
    protected readonly AccessType = AccessType;
}
